// src/components/ThirdPartyContact/Components/ThirdPartyContactDataGridColumns.js
import React from "react";
import { Box } from "@mui/material";
import { CheckCircle, Cancel } from "@mui/icons-material";
import ThirdPartyContactActionCell from "./ThirdPartyContactActionCell";

export function getThirdPartyContactColumns(onEditContact) {
  const actionsColumn = {
    field: "actions",
    headerName: "Actions",
    width: 100,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <ThirdPartyContactActionCell
        id={params.row.id}
        row={params.row}
        onEditContact={onEditContact}
      />
    ),
  };

  return [
    { field: "id", headerName: "ID", flex: 0.5, minWidth: 100, },
    { field: "fullName", headerName: "Fullname", flex: 1.2, minWidth: 170 },
    { field: "email", headerName: "Email Address", flex: 1.5, minWidth: 200 },
    {
      field: "identifiers",
      headerName: "Identifiers",
      flex: 1,
      minWidth: 130,
      renderCell: (params) => {
        const endpoints = params.row.endpoints || [];
        const identifiers = endpoints.map((ep) => ep.identifier).join(", ");
        return <span>{identifiers || <em>No endpoints</em>}</span>;
      },
    },
    {
      field: "isActive",
      headerName: "Active",
      flex: 0.7,
      minWidth: 140,
      type: "boolean",
      renderCell: (params) => (
        <Box display="flex" alignItems="center" justifyContent="center">
          {params.value ? (
            <CheckCircle color="success" />
          ) : (
            <Cancel color="error" />
          )}
        </Box>
      ),
    },
    {  
      ...actionsColumn,
      flex: 0.5,
      minWidth: 80,
    },
  ];
}
